module.exports = __webpack_public_path__ + "static/media/pic6.fab3de5c.jpg";